import thumb_up from "../images/thumb_up.svg";
import thumb_down from "../images/thumb_down.svg";
import {keydownHandler} from "../utils/commonHelper";
import React, {useEffect, useState} from "react";
import Loader from "react-loader-spinner";

export const FeedbackBaseConfig = {
    thumbUp: {
        value: 1,
        className: 'thumb-up',
        loader: {
            width: 24,
            height: 24
        },
        component: <img src={thumb_up} alt=""/>
    },
    thumbDown: {
        value: 0,
        className: 'thumb-down',
        loader: {
            width: 24,
            height: 24
        },
        component: <img src={thumb_down} alt=""/>
    }
};
const LOADER_STATUS_LOADING = 1;

const Feedback = (props) => {
    const [isShown, setIsShown] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsShown(true);
        }, props.waitBeforeShow);
        return () => clearTimeout(timer);
    }, [props.waitBeforeShow]);
    const [config, setConfig] = useState(props.feedbackConfig ? props.feedbackConfig : FeedbackBaseConfig);
    const [feedbackValue, setFeedbackValue] = useState(props.feedbackValue);
    useEffect(() => {
        setFeedbackValue(props.feedbackValue)
    }, [props.feedbackValue])
    const {contactId, onUpdateFeedback, feedbackLoaderStatus} = props;
    const changeRating = (question, rating) => {
        onUpdateFeedback({
            ...feedbackValue,
            [contactId]: {...feedbackValue[contactId], [question]: rating}
        })
    }
    const chatEnded = props.agents[contactId] ? props.agents[contactId].chatEnded : false

    return isShown && <div className={"feedback-box " + (!chatEnded ? "transferring" : "")}>
        {
            (chatEnded || props.showCancelFeedback) && <div className="title">
                Please help us improve by completing this short feedback survey.
            </div>
        }
        {
            feedbackLoaderStatus === LOADER_STATUS_LOADING ?
                <div className={"feedback-loader"}>
                    <Loader
                        type="Oval"
                        color="#02818A"
                        timeout={0}
                    />
                </div>
                :
                ""
        }
        <div>
            {
                (chatEnded || props.showCancelFeedback) &&
                <Question config={config} contactId={contactId} changeRating={changeRating}
                          feedbackValue={feedbackValue} questionName={'helpReceived'}
                          questionTitle={'Did you receive the help you needed?'}
                          sendFeedback={props.sendFeedback} chatEnded={chatEnded}
                          showCancelFeedback={props.showCancelFeedback}/>
            }
            <Question config={config} contactId={contactId} changeRating={changeRating}
                      feedbackValue={feedbackValue} questionName={'feedbackResult'}
                      questionTitle={'Please rate your chat with ' + (props.agents[props.contactId].agentName)}
                      sendFeedback={props.sendFeedback} chatEnded={chatEnded}
                      showCancelFeedback={props.showCancelFeedback}/>
        </div>
    </div>
}

const ThumbsButton = ({
                          config,
                          contactId,
                          changeRating,
                          feedbackValue,
                          questionName,
                          disabled,
                          sendFeedback,
                          chatEnded,
                          showCancelFeedback
                      }) => {
    const onChangeFeedback = (question, rate) => {
        changeRating(question, rate);
    }
    const isSelected = feedbackValue[contactId] && feedbackValue[contactId][questionName] === config.value;
    return (
        <a className={(isSelected ? 'selected' : '') + ' ' + config.className}
           tabIndex={0}
           onKeyDown={keydownHandler}
           disabled={disabled}
           onClick={() => chatEnded || showCancelFeedback ? onChangeFeedback(questionName, config.value) : sendFeedback(contactId, config.value)}>
            {
                config.component
            }
        </a>
    );
}
export const Question = ({
                             config,
                             contactId,
                             changeRating,
                             feedbackValue,
                             questionTitle,
                             questionName,
                             disabled,
                             sendFeedback,
                             chatEnded,
                             showCancelFeedback
                         }) => {
    return <div className="rate-box">
        {questionTitle}
        <div className="thumbs">
            <ThumbsButton
                config={config.thumbUp}
                contactId={contactId}
                changeRating={changeRating}
                feedbackValue={feedbackValue}
                questionName={questionName}
                disabled={disabled}
                sendFeedback={sendFeedback}
                chatEnded={chatEnded}
                showCancelFeedback={showCancelFeedback}
            />
            <ThumbsButton
                config={config.thumbDown}
                contactId={contactId}
                changeRating={changeRating}
                feedbackValue={feedbackValue}
                questionName={questionName}
                disabled={disabled}
                sendFeedback={sendFeedback}
                chatEnded={chatEnded}
                showCancelFeedback={showCancelFeedback}
            />
        </div>
    </div>
}
export default Feedback;
